import Link from 'next/link'
import { IAgenadaItem, IAgendaGroup, IAgendaDay, day1, day2 } from 'content/agenda'
import { Button, SEO } from '@martech/ig-summit-ui'
import styles from './index.module.css'
import Image from 'next/image'
import { useState, FC } from 'react'

const AgendaItem: FC<IAgenadaItem> = ({ time, title, image, description }) => (
  <div className={`relative m_x-xs grid ${styles.grid} ${styles.underline}`}>
    <div className={`text-s`}>{time}</div>
    <div className={`grid ${styles['grid-inside']}`}>
      <div className={`text-s flex d-jcc`}>
        <div className={styles.image}>
          <Image
            src={image}
            alt=""
            style={{
              objectFit: 'contain',
            }}
          />
        </div>
      </div>
      <div className={`text-s ${styles.item} ${styles.text}`}>{title}</div>
      <div className={`text-s ${styles.text}`}>{description ? description : ''}</div>
    </div>
  </div>
)

const AgendaGroup: FC<IAgendaGroup> = ({ title, breakouts }) => {
  const [activeTab, setActiveTab] = useState(breakouts[0])
  const isSubtitles = breakouts.filter(({ title }) => title).length > 0
  return (
    <div className={`relative ${styles.width}`}>
      <div className={styles.scrollto} />
      {title && (
        <div
          className={`p_x-xs ${!isSubtitles ? `${styles.sticky} ${styles['sticky-title']}` : ''}`}
        >
          <div className={`text-m-accident ${styles.title}`}>{title}</div>
        </div>
      )}
      {isSubtitles && (
        <div className={`${styles.sticky} ${styles['sticky-title']}`}>
          <div className="flex scroll-x p_x-xs">
            {breakouts.map((breakout) => {
              return (
                <div
                  className={`text-m-accident ${styles.subtitle} ${
                    activeTab?.title === breakout.title ? styles['is-active'] : ''
                  }`}
                  onClick={() => setActiveTab(breakout)}
                  key={breakout.title}
                >
                  {breakout.title}
                </div>
              )
            })}
          </div>
        </div>
      )}
      {activeTab?.note && (
        <div className={`text-s p_x-xs text-center ${styles.note}`}>{activeTab?.note}</div>
      )}
      {activeTab?.items.map((item) => (
        <AgendaItem {...item} />
      ))}
    </div>
  )
}

const AgendaDay: FC<IAgendaDay> = ({ title, date, timelineGroups }) => (
  <section className={`grid relative m_b-m ${styles.container} ${styles.dayline}`}>
    <div>
      <div className={`m_x-xs ${styles.day} ${styles.sticky}`}>
        <h3>{title}</h3>
        <p className="text-s">{date}</p>
      </div>
    </div>
    <div>
      {timelineGroups.map((group, j) => (
        <AgendaGroup {...group} key={j} />
      ))}
    </div>
  </section>
)

const AgendaPage = () => (
  <>
    <SEO title="Instagram Summit 2022 | ManyChat | Agenda" keywords="agenda" description="agenda" />
    <div className="set-color" data-back="#abefa0" data-front="#020202">
      <section className="m_t-xs m_b-xl">
        <Link href="/" className="m_x-xs text-action">
          ← back to homepage
        </Link>
        <h2 className="p_x-xs m_t-s text-center">Agenda</h2>
      </section>
      <AgendaDay {...day1} />
    </div>
    <div className="set-color" data-back="#6a34bf" data-front="#fff">
      <AgendaDay {...day2} />
      <div className="t-flex jcc m_x-xs m_t-xxl m_b-xxl">
        <Button href="https://events.hubilo.com/igsummit-2022" target="_blank">
          Go to Summit
        </Button>
      </div>
    </div>
  </>
)

export default AgendaPage
